import PropTypes from 'prop-types'
import React from 'react'
// eslint-disable-next-line max-len
import { ReactComponent as SvgIcon } from '@v4/../../assets/fonts/FontAwesomeKit/icons/circle-check-regular.svg'
import BaseIcon from '../../BaseIcon'

const CircleCheck = ({ className }) => {
	return <BaseIcon component={SvgIcon} className={className} viewBox="0 0 640 640" />
}

CircleCheck.propTypes = {
	className: PropTypes.string,
}

CircleCheck.defaultProps = {
	className: null,
}

export default CircleCheck
